class StoreDeviceCoordinate {
  constructor (
    id = null,
    date = undefined,
    lat,
    lng,
    speed,
    direction,
    horizontalAccuracy,
    altitude,
    floor,
    verticalAccuracy,
    locationString,
    deviceId
  ) {
    this.id = id
    this.date = new Date(date)
    this.lat = lat
    this.lng = lng
    this.speed = speed
    this.direction = direction
    this.horizontalAccuracy = horizontalAccuracy
    this.altitude = altitude
    this.floor = floor
    this.verticalAccuracy = verticalAccuracy
    this.locationString = locationString
    this.deviceId = deviceId
    this.device = null
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      // date is read-only
      lat: this.lat,
      lng: this.lng,
      speed: this.speed,
      direction: this.direction,
      horizontalAccuracy: this.horizontalAccuracy
      // locationString is read-only
      // deviceId is read-only
    })
  }

  static FromNormalizedRESTModel ({
    id,
    date,
    lat,
    lng,
    speed,
    direction,
    horizontalAccuracy,
    altitude,
    floor,
    verticalAccuracy,
    locationString,
    deviceId
  }) {
    return new StoreDeviceCoordinate(
      id,
      date,
      lat,
      lng,
      speed,
      direction,
      horizontalAccuracy,
      altitude,
      floor,
      verticalAccuracy,
      locationString,
      deviceId
    )
  }

  toJSON () {
    return {
      id: this.id,
      date: this.date,
      lat: this.lat,
      lng: this.lng,
      speed: this.speed,
      direction: this.direction,
      horizontalAccuracy: this.horizontalAccuracy,
      altitude: this.altitude,
      floor: this.floor,
      verticalAccuracy: this.verticalAccuracy,
      locationString: this.locationString,
      deviceId: this.deviceId
    }
  }

  static FromJSON ({
    id,
    date,
    lat,
    lng,
    speed,
    direction,
    horizontalAccuracy,
    altitude,
    floor,
    verticalAccuracy,
    locationString,
    deviceId
  }) {
    return new StoreDeviceCoordinate(
      id,
      date,
      lat,
      lng,
      speed,
      direction,
      horizontalAccuracy,
      altitude,
      floor,
      verticalAccuracy,
      locationString,
      deviceId
    )
  }
}

export default StoreDeviceCoordinate
